const LandingPageWrapper = ({
    children
}) => {

    return (
        <div className="h-100 d-flex flex-column">
            <div className="flex-grow-1 mt-xxl-5 mt-3 mb-2 overflow-auto">
                <div className="container d-flex justify-content-center">
                    <div className="bg-white rounded px-3 px-md-5 py-5 d-flex flex-column align-items-center justify-content-center">
                        <div>
                            <img src="/favicon.svg" className="favicon" alt="OnTheMove" />
                        </div>
                        <div className="text-center">
                            <label className="display-6 mt-2">
                                <strong>{process.env.REACT_APP_PRODUCT_NAME}</strong>
                            </label>
                        </div>
                        <div className="mt-4 w-100">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-end mb-3 me-3">
                <a href={process.env.REACT_APP_OWN_WEBSITE} className="text-secondary">onthemovesw.com</a>
                <div>
                    <label>For support, email <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}?subject=Request Support`} className="text-secondary">{process.env.REACT_APP_SUPPORT_EMAIL}</a></label>
                </div>
            </div>
        </div>
    );
};

export default LandingPageWrapper;